module.exports = __webpack_public_path__ + "comment.c18d2b4f.png";